import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {},
	publishPopup: {
		maxWidth: 480,
	},
	publishDescription: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		lineHeight: 1.5,
		margin: 0,
	},
});
